import {
  PapiDeviation,
  PapiGallection,
  PapiUser,
  PapiRequestDaSharedGallectionFoldersSetDeviationsAttr,
  PapiRequestDaSharedDeviationFetch,
} from '@wix/da-papi-types';
import { createAction } from 'redux-actions';
import { DeviationResourceType, DeviationTypes } from '../types/deviation';
import { MediaSourceType, MediaPopupMode } from './types';
import { UploadFilePayload } from '../redux/uploads/types';

export interface InitMediaPopupPayload {
  mode: MediaPopupMode;
  mediaSource: MediaSourceType;
  gallectionFolder?: PapiGallection;
  tier?: PapiDeviation;
  mediaSourceTypes?: MediaSourceType[];
  withMediaSourceSelector?: boolean;
  initialDeviationSet?: PapiDeviation[];
  selectionLimit?: number;
  allowedDeviationTypes?: DeviationTypes[];
  allowedDeviationResourceTypes?: DeviationResourceType[];
  allowGifs?: boolean;
  allowPremium?: boolean;
  allowInTierContent?: boolean;
  allowDefaultImage?: boolean;
  allowMature?: boolean;
  allowUploads?: boolean;
  allowMultipleUploads?: boolean;
  ignoreDeviationIds?: number[];
  minDeviationWidth?: number;
  minDeviationHeight?: number;
  withNewGallectionPopupOpen?: boolean;
  withAddDeviationsPopupOpen?: boolean;
  entities?: object;
  gruser?: PapiUser;
}

export type ChangeCurrentMediaSourcePayload = MediaSourceType;

export interface InitGallectionStreamPayload {
  folderId?: number;
}

export const initMediaPopup = createAction(
  '@@MediaPopup/INITIALIZE',
  (payload: InitMediaPopupPayload) => payload
);

export const initGallectionStream = createAction(
  '@@MediaPopup/GALLECTIONS_STREAM/INITIALIZE',
  (payload: InitGallectionStreamPayload) => payload
);

export const initBrowseStream = createAction(
  '@@MediaPopup/BROWSE_STREAM/INITIALIZE',
  () => ({})
);

export const initTierStream = createAction(
  '@@MediaPopup/BROWSE_TIER/INITIALIZE',
  () => ({})
);

export const initCommissionStream = createAction(
  '@@MediaPopup/COMMISSION_STREAM/INITIALIZE',
  () => ({})
);

export const initGallectionDeviationStream = createAction(
  '@@MediaPopup/GALLECTION_DEVIATIONS_STREAM/INITIALIZE',
  () => ({})
);

export const initTierDeviationStream = createAction(
  '@@MediaPopup/TIER_DEVIATIONS_STREAM/INITIALIZE',
  () => ({})
);

export const initCustomSetDeviationStream = createAction(
  '@@MediaPopup/CUSTOM_SET_DEVIATION_STREAM/INITIALIZE',
  (payload: PapiDeviation[]) => payload
);

export const initPostStream = createAction(
  '@@MediaPopup/POST_STREAM/INITIALIZE',
  (payload: ChangeCurrentMediaSourcePayload) => payload
);

export const initSingleDeviationByLookupStream = createAction(
  '@@MediaPopup/SINGLE_DEVIATION_BY_LOOKUP/INITIALIZE',
  (payload: PapiRequestDaSharedDeviationFetch) => payload
);

export const showNewFolderPopup = createAction(
  '@@MediaPopup/SHOW_NEW_FOLDER_POPUP',
  () => ({})
);

export const hideNewFolderPopup = createAction(
  '@@MediaPopup/HIDE_NEW_FOLDER_POPUP',
  () => ({})
);

export const showAddDeviationsPopup = createAction(
  '@@MediaPopup/SHOW_ADD_DEVIATIONS_POPUP',
  () => ({})
);

export const hideAddDeviationsPopup = createAction(
  '@@MediaPopup/HID_ADD_DEVIATIONS_POPUP',
  () => ({})
);

export const setCurrentFolderId = createAction(
  '@@MediaPopup/SET_CURRENT_FOLDER_ID',
  (payload: number) => payload
);

export const unsetCurrentFolderId = createAction(
  '@@MediaPopup/UNSET_CURRENT_FOLDER_ID',
  () => ({})
);

export const setCurrentSubfolderId = createAction(
  '@@MediaPopup/SET_CURRENT_SUBFOLDER_ID',
  (payload: number) => payload
);

export const unsetCurrentSubfolderId = createAction(
  '@@MediaPopup/UNSET_CURRENT_SUBFOLDER_ID',
  () => ({})
);

export const setCurrentTierId = createAction(
  '@@MediaPopup/SET_CURRENT_TIER_ID',
  (payload: number) => payload
);

export const unsetCurrentTierId = createAction(
  '@@MediaPopup/UNSET_CURRENT_TIER_ID',
  () => ({})
);

export const changeCurrentMediaSource = createAction(
  '@@MediaPopup/SET_MEDIA_SOURCE',
  (payload: ChangeCurrentMediaSourcePayload) => payload
);

export const setSearchInput = createAction(
  '@@MediaPopup/SET_SEARCH_INPUT',
  (payload: string) => payload
);

export const unsetSearchInput = createAction(
  '@@MediaPopup/UNSET_SEARCH_INPUT',
  () => ({})
);

export const setSearchQuery = createAction(
  '@@MediaPopup/SET_SEARCH_QUERY',
  (query: string, allowSearchByUrl?: boolean) => ({ query, allowSearchByUrl })
);

export const unsetSearchQuery = createAction(
  '@@MediaPopup/UNSET_SEARCH_QUERY',
  () => ({})
);

// FETCH

export const fetchMoreBrowseDeviations = createAction(
  '@@MediaPopup/FETCH_MORE_BROWSE_DEVIATIONS',
  () => ({})
);

export const fetchMorePosts = createAction(
  '@@MediaPopup/FETCH_MORE_POSTS',
  () => ({})
);

export const fetchMoreTiers = createAction(
  '@@MediaPopup/FETCH_MORE_TIERS',
  () => ({})
);

export const fetchMoreCommissions = createAction(
  '@@MediaPopup/FETCH_MORE_COMMISSIONS',
  () => ({})
);

export const fetchMoreGallections = createAction(
  '@@MediaPopup/FETCH_MORE_GALLECTIONS',
  () => ({})
);

export const fetchMoreGallectionsDone = createAction(
  '@@MediaPopup/FETCH_MORE_GALLECTIONS_DONE',
  (success: boolean, type: MediaSourceType) => ({ success, type })
);

export const fetchMoreGallectionDeviations = createAction(
  '@@MediaPopup/FETCH_MORE_GALLECTION_DEVIATIONS',
  () => ({})
);

export const fetchMoreTierDeviations = createAction(
  '@@MediaPopup/FETCH_MORE_TIER_DEVIATIONS',
  () => ({})
);

// SELECTION

export const onSelectableItemClick = createAction(
  '@@MediaPopup/ON_SELECTABLE_ITEM_CLICK',
  (payload: PapiDeviation) => payload
);

// replace currently selected one (if there's such) with a given one
export const replaceSelect = createAction(
  '@@MediaPopup/REPLACE_SELECT',
  (payload: PapiDeviation) => payload
);

export const deselect = createAction(
  '@@MediaPopup/DESELECT',
  (payload: PapiDeviation) => payload
);
export const deselectMulti = createAction(
  '@@MediaPopup/DESELECT_MULTI',
  (payload: PapiDeviation[]) => payload
);
export const deselectAll = createAction(
  '@@MediaPopup/DESELECT_ALL',
  () => ({})
);

// toggleAppen - deselect if selected, append to the list of selected if not
export const toggleAppendSelect = createAction(
  '@@MediaPopup/TOGGLE_APPEND_SELECT',
  (payload: PapiDeviation) => payload
);

// MANAGEMENT

// DEVIATION MANAGEMENT

export type AddDeviationsPayload = PapiDeviation[];
export const addDeviations = createAction(
  '@@MediaPopup/DEVIATION/ADD',
  (payload: AddDeviationsPayload) => payload
);

export interface MoveDeviationToPositionPayload {
  deviation: PapiDeviation;
  position: number;
  moveType?: 'streamOnly' | 'papiOnly';
}
export const moveDeviationToPosition = createAction(
  '@@MediaPopup/DEVIATION/MOVE_TO_POSITION',
  (payload: MoveDeviationToPositionPayload) => payload
);

export type RemoveDeviationsPayload = PapiDeviation[];
// remove deviations from whatever folder they reside in
export const removeDeviations = createAction(
  '@@MediaPopup/DEVIATION/REMOVE',
  (payload: RemoveDeviationsPayload) => payload
);

export interface CopyDeviationsPayload {
  targetFolderId: number;
  deviations: PapiDeviation[];
}
export const copyDeviations = createAction(
  '@@MediaPopup/DEVIATION/COPY',
  (payload: CopyDeviationsPayload) => payload
);

export interface MoveDeviationsPayload {
  targetFolderId: number;
  deviations: PapiDeviation[];
}
export const moveDeviations = createAction(
  '@@MediaPopup/DEVIATION/MOVE',
  (payload: MoveDeviationsPayload) => payload
);

export type MakeDeviationCurrentGallectionCoverPayload = PapiDeviation;
export const makeDeviationCurrentGallectionCover = createAction(
  '@@MediaPopup/DEVIATION/MAKE_GALLECTION_COVER',
  (payload: MakeDeviationCurrentGallectionCoverPayload) => payload
);

// GALLECTION MANAGEMENT

export type RemoveGallectionPayload = number;
export const removeGallection = createAction(
  '@@MediaPopup/GALLECTION/REMOVE',
  (payload: RemoveGallectionPayload) => payload
);

export interface CreateGallectionPayload {
  name: string;
  folderType: 'paid' | 'watchers' | 'regular';
  priceInPoints?: number;
}
export const createGallection = createAction(
  '@@MediaPopup/GALLECTION/CREATE',
  (payload: CreateGallectionPayload) => payload
);

export interface MoveGallectionPayload {
  folderId: number;
  toFolderId: number;
}
export const moveGallection = createAction(
  '@@MediaPopup/GALLECTION/MOVE',
  (payload: MoveGallectionPayload) => payload
);

export interface labelAsPayload {
  gallection?: PapiGallection;
  deviationIds?: number[];
  attribute: PapiRequestDaSharedGallectionFoldersSetDeviationsAttr['attr_name'];
  value: boolean;
}
export const labelAs = createAction(
  '@@MediaPopup/LABEL_AS',
  (payload: labelAsPayload) => payload
);

export interface MoveGallectionToPositionPayload {
  folderId: number;
  position: number;
  moveType?: 'streamOnly' | 'papiOnly';
}
export const moveGallectionToPosition = createAction(
  '@@MediaPopup/GALLECTION/MOVE_TO_POSITION',
  (payload: MoveGallectionToPositionPayload) => payload
);

export interface ChangeGallectionNamePayload {
  folderId: number;
  name: string;
}
export const setGallectionName = createAction(
  '@@MediaPopup/GALLECTION/SET_NAME',
  (payload: ChangeGallectionNamePayload) => payload
);

export interface ChangeGallectionDescriptionPayload {
  folderId: number;
  description: string;
}
export const setGallectionDescription = createAction(
  '@@MediaPopup/GALLECTION/SET_DESCRIPTION',
  (payload: ChangeGallectionDescriptionPayload) => payload
);

export interface SetGallectionPricePayload {
  folderId: number;
  pointsPrice: number;
}
export const setGallectionPrice = createAction(
  '@@MediaPopup/GALLECTION/SET_GALLECTION_PRICE',
  (payload: SetGallectionPricePayload) => payload
);

export interface SetGallectionCoverPayload {
  gallection: PapiGallection;
  deviation: PapiDeviation;
}
export const setGallectionCover = createAction(
  '@@MediaPopup/GALLECTION/SET_GALLECTION_COVER',
  (payload: SetGallectionCoverPayload) => payload
);

// FILE UPLOAD

export const uploadFile = createAction(
  '@@MediaPopup/UPLOAD/FILE',
  (payload: Partial<UploadFilePayload>) => payload
);

export const uploadFiles = createAction(
  '@@MediaPopup/UPLOAD/FILES',
  (payload: Partial<UploadFilePayload>[]) => payload
);

export const reloadStashStream = createAction(
  '@@MediaPopup/RELOAD/STASH/STREAM',
  () => ({})
);

export const reloadStashStreamDone = createAction(
  '@@MediaPopup/RELOAD/STASH/STREAM/DONE',
  () => ({})
);

export const convertGallery = createAction(
  '@@MediaPopup/CONVERT_GALLERY',
  () => ({})
);
